import { Tooltip } from "react-migration/components/Tooltip";
import type { RecursiveTree, RenderNodeBadge } from "../types";
import { Theme } from "react-migration/lib/theme/Theme";

export type LabelItem = {
  label: JSX.Element;
};

export interface LabelTreeRecursiveProps {
  renderNodeBadge?: RenderNodeBadge;
}

export type LabelTreeProps = {
  display_name: string;
  description?: string | undefined;
};

export function labelTreeRecursive<U>(
  tree: RecursiveTree<U & LabelTreeProps>,
  props: LabelTreeRecursiveProps
): RecursiveTree<LabelItem & U> {
  const { renderNodeBadge } = props;

  const childNodes = tree.childNodes.map((n) => labelTreeRecursive(n, props));

  const isLeafNode = !childNodes.length;
  let label = <>{tree.display_name}</>;

  if (isLeafNode) {
    label = (
      <div className="flex w-11/12 gap-2">
        {renderNodeBadge?.(tree)}
        <div className="overflow-hidden shrink text-ellipsis">
          <Tooltip.Wrapper>
            <Tooltip.Content align="start" side="bottom" theme={Theme.Dark} size="sm">
              <Tooltip.Header>{tree.display_name}</Tooltip.Header>
              <Tooltip.Description>{tree.description}</Tooltip.Description>
            </Tooltip.Content>
            <Tooltip.Trigger>
              <div>{label}</div>
            </Tooltip.Trigger>
          </Tooltip.Wrapper>
        </div>
      </div>
    );
  }

  return {
    ...tree,
    childNodes,
    label,
  };
}
